import angular from 'angular';
import {getProxyPrefix} from '../common/util/url-util'

export default angular.module('app.services.corsProxy',[])
  .service('corsProxy', () => {
    return { getProxyPrefix }
  });


/** WEBPACK FOOTER **
 ** ./src/services/corsProxy.js
 **/